"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleSidebar = undefined;

var _index = require("./index");

var _reduxActions = require("redux-actions");

// public action creators
var toggleSidebar = exports.toggleSidebar = (0, _reduxActions.createAction)(_index.APP_TOGGLE_SIDEBAR);


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/app/actions.ts
 ** module id = 1289
 ** module chunks = 0
 **/